import React from 'react';
import PropTypes from 'prop-types';

import IconDimensions from 'components/icons/IconDimensions';
import { colorGrayLight2 } from 'styles/layout/colors';

const PDPMobileDimensionsIcon = ({ onClick }) => (
  <button
    type="button"
    className="items-center bg-white border border-solid border-gray-light7 rounded-[40px] text-white flex justify-center h-10 w-10 hover:cursor-pointer"
    onClick={onClick}
  >
    <IconDimensions width={16} height={16} color={colorGrayLight2} />
  </button>
);

PDPMobileDimensionsIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PDPMobileDimensionsIcon;
